import { createEffect } from "solid-js"
import { MapView } from "./components/MapView"
import { Sidebar } from "./components/Sidebar"
import { TrackerHud } from "./components/TrackerHud"
import { mapController } from "./map/controller"
import { app } from "./store/app"

export default function App() {
  createEffect(() => {
    document.body.classList.toggle("sidebar-collapsed", app.sidebarCollapsed() && !app.sidebarExpanded())
    document.body.classList.toggle("sidebar-expanded", app.sidebarExpanded())
    queueMicrotask(() => mapController.invalidate())
  })

  return (
    <>
      <Sidebar />
      <button
        id="sidebar-toggle"
        aria-label="Toggle sidebar"
        onClick={() => {
          if (app.sidebarExpanded()) {
            app.setSidebarExpanded(false)
            return
          }
          app.setSidebarCollapsed(!app.sidebarCollapsed())
        }}
      >
        {app.sidebarExpanded() ? "⧉" : "☰"}
      </button>
      <MapView />
      <TrackerHud />
    </>
  )
}
